import { combineReducers } from "redux";
import user from "reducers/user";
import reader from "reducers/reader";
import accessCard from "reducers/accessCard";
import accessLevel from "reducers/accessLevel";
import location from "reducers/location";
import login from "reducers/login";

const rootReducer = combineReducers({
  user,
  reader,
  accessCard,
  accessLevel,
  location,
  login
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js